import { Instagram, Facebook } from 'lucide-react';

import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t, i18n } = useTranslation();
  return (
    <footer
      data-testid="footer"
      className="py-12 px-6 sm:px-8"
      style={{ backgroundColor: 'var(--vc-bg)' }}
    >
      <div className="max-w-[1160px] mx-auto">
        <div
          aria-hidden="true"
          className="h-px w-full mb-12"
          style={{
            background: 'linear-gradient(to right, transparent, rgba(214,168,74,0.25), transparent)',
          }}
        />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <img
              src="/images/logo.png"
              alt="Verse Clinic"
              className="h-12 sm:h-10"
              style={{ display: 'block' }}
            />
            <span
              className="text-xs"
              style={{ color: 'var(--vc-fg-subtle)', fontFamily: 'Inter, sans-serif' }}
            >
              {t('footer.copyright')}
            </span>
          </div>
          <div className="flex items-center gap-4">
            <a
              href="https://instagram.com/verseclinic.my/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-200"
              style={{
                backgroundColor: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(214,168,74,0.15)';
                e.currentTarget.style.borderColor = 'rgba(214,168,74,0.35)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.06)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
              }}
            >
              <Instagram className="w-4 h-4" style={{ color: 'var(--vc-fg-muted)' }} />
            </a>
            <a
              href="https://www.facebook.com/verse.clinic/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-200"
              style={{
                backgroundColor: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(214,168,74,0.15)';
                e.currentTarget.style.borderColor = 'rgba(214,168,74,0.35)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.06)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
              }}
            >
              <Facebook className="w-4 h-4" style={{ color: 'var(--vc-fg-muted)' }} />
            </a>
            <a
              href={`https://wa.me/601165337469?text=${i18n.language?.startsWith('zh') ? encodeURIComponent('您好，我希望加入 VERSE Clinic 的专属候补名单，了解更多长寿与再生医学方案。') : encodeURIComponent('Hi, I would like to join the waitlist for VERSE Clinic.')}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-200"
              style={{
                backgroundColor: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(214,168,74,0.15)';
                e.currentTarget.style.borderColor = 'rgba(214,168,74,0.35)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.06)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
              }}
            >
              {/* WhatsApp SVG icon */}
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
                  style={{ fill: 'var(--vc-fg-muted)' }}
                />
                <path
                  d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 01-4.28-1.238l-.307-.184-2.87.853.853-2.87-.184-.307A8 8 0 1112 20z"
                  style={{ fill: 'var(--vc-fg-muted)' }}
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
